import { Injectable } from '@angular/core';

import { NavigationEnd, Router } from '@angular/router';
import { TColumn } from 'src/app/project/modules/site/site-table/columns/column.model';
import { AccountService } from '../../modules/account/account-service/account.service';
import { GET_CUSTOM_FIELDS } from '../../modules/custom-fields/custom-fields.store';
import { WorkspaceService } from '../../modules/workspace/workspace.service';
import { simplifyRoute } from '../../shared/utils/simplify-route';
import { ActiveService } from '../active/active.service';
import { configGTAG, logEventInGTAG, pushUserToDataLayer } from './google-analytics';
import {
  EGoogleEventCategory,
  TGoogleEventParams,
  TGoogleTagEventsUnion,
} from './google-analytics.consts';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private googleAnalyticsAccountCode = 'UA-72811857-2';

  constructor(
    private router: Router,
    private activeService: ActiveService,
    private workspaceService: WorkspaceService,
    private accountService: AccountService,
  ) {}

  logEvent({
    eventName,
    source,
    format = null,
    type = null,
    sub_type = null,
    length = null,
    total = null,
    count = null,
    method = null,
  }: {
    eventName: TGoogleTagEventsUnion;
    source: EGoogleEventCategory;
    format?: string;
    type?: string;
    sub_type?: string;
    length?: number;
    total?: number;
    count?: number;
    method?: string;
  }): void {
    const event: TGoogleEventParams = {
      source,
      format,
      type,
      sub_type,
      length,
      total,
      count,
      method,
    };

    logEventInGTAG(eventName, event);
  }

  getColumnType(column: TColumn): string {
    if (column.customFieldIds?.length > 0) {
      const customFields = GET_CUSTOM_FIELDS();
      const customField = customFields[column.customFieldIds[0]];

      return customField ? customField.type : column.name;
    } else {
      return column.name;
    }
  }

  subscribeToRouteChange(): void {
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }

      const active = this.activeService.getActiveWorkspaceId();
      const workspace = this.workspaceService.getWorkspace(active);
      const account = this.accountService.getAccount(workspace?.accountId);
      const parsedURL = this.router.parseUrl(event.urlAfterRedirects);
      const fixedPath = simplifyRoute(parsedURL?.root?.children?.primary?.segments);

      configGTAG(this.googleAnalyticsAccountCode, {
        path: fixedPath,
        shareOption: workspace?.share.shareOption,
        industryType: account?.industryType,
        accountType: account?.accountType,
      });

      pushUserToDataLayer({
        user_role: workspace?.share.shareOption,
      });
    });
  }
}
